/**
 * What to say after a status update: what happened to the case, then whether the client was
 * emailed (Lloyd, 23 Oct 2026: "I tried to send an update on the status through her case file and
 * it didn't look like it sent.").
 *
 * The client sentence is the server's own (`notifications.client.message` from
 * POST /manager/ticket-status), because only the server knows whether the client was on the
 * recipient list. A response without it says only what happened to the case, rather than guessing.
 */
export function statusUpdateMessage(lead: string, body: unknown): string {
  const client = (body as { notifications?: { client?: { message?: unknown } } } | null)
    ?.notifications?.client?.message;
  return typeof client === 'string' && client.trim() ? `${lead} ${client.trim()}` : lead;
}
